import { doLogout } from 'actions/authAction';
import { BASE_URL } from './constant';

const GET_LIST_CHAT_URL = "chat/get-list";
export const GET_LIST_CHAT_LOADING = "GET_LIST_CHAT_LOADING";
export const GET_LIST_CHAT_SUCCESS = "GET_LIST_CHAT_SUCCESS";
export const GET_LIST_CHAT_ERROR = "GET_LIST_CHAT_ERROR";

const getListChatLoadingAction = (bool) => {
  return {
    type: GET_LIST_CHAT_LOADING,
    getListChatLoading: bool
  };
};

const getListChatSuccessAction = (bool, getListChatData) => {
  return {
    type: GET_LIST_CHAT_SUCCESS,
    getListChatSuccess: bool,
    getListChatData
  };
};

const getListChatErrorAction = (bool) => {
  return {
    type: GET_LIST_CHAT_ERROR,
    getListChatError: bool
  };
};

export function getListChat(data) {
  return (dispatch) => {
    dispatch(getListChatLoadingAction(true));
    dispatch(getListChatSuccessAction(false, null));
    dispatch(getListChatErrorAction(false));

    let token = localStorage.getItem('tolaut@token') || null;
    let config = {};

    config = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(BASE_URL + GET_LIST_CHAT_URL, config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }

      if (!response.ok) {
        throw Error(response.statusText);
      }
      
      return response;
    })
    .then((response) => response.json())
    .then((res) => {
      dispatch(getListChatLoadingAction(false));
      dispatch(getListChatSuccessAction(true, res));
    })
    .catch((err) => {
      dispatch(getListChatErrorAction(true));
    });
  };
};

const GET_MESSAGE_CHAT_URL = "chat/get-message-chat";
export const GET_MESSAGE_CHAT_LOADING = "GET_MESSAGE_CHAT_LOADING";
export const GET_MESSAGE_CHAT_SUCCESS = "GET_MESSAGE_CHAT_SUCCESS";
export const GET_MESSAGE_CHAT_ERROR = "GET_MESSAGE_CHAT_ERROR";

const getMessageChatLoadingAction = (bool) => {
  return {
    type: GET_MESSAGE_CHAT_LOADING,
    getMessageChatLoading: bool
  };
};

const getMessageChatSuccessAction = (bool, getMessageChatData, email, keyRoom, friendId, namaPerusahaan) => {
  return {
    type: GET_MESSAGE_CHAT_SUCCESS,
    getMessageChatSuccess: bool,
    getMessageChatData,
    email,
    keyRoom,
    friendId,
    namaPerusahaan
  };
};

const getMessageChatErrorAction = (bool) => {
  return {
    type: GET_MESSAGE_CHAT_ERROR,
    getMessageChatError: bool
  };
};

export function getMessageChat(data, email, keyRoom, friendId, namaPerusahaan) {
  return (dispatch) => {
    dispatch(getMessageChatLoadingAction(true));
    dispatch(getMessageChatSuccessAction(false, null, null, null, null, null));
    dispatch(getMessageChatErrorAction(false));

    let token = localStorage.getItem('tolaut@token') || null;
    let config = {};

    config = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(BASE_URL + GET_MESSAGE_CHAT_URL, config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }

      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      dispatch(getMessageChatLoadingAction(false));
      dispatch(getMessageChatSuccessAction(true, data, email, keyRoom, friendId, namaPerusahaan));
    })
    .catch((err) => {
      dispatch(getMessageChatErrorAction(true));
    });
  };
};

const SEND_MESSAGE_CHAT_URL = "chat/send-message";
export const SEND_MESSAGE_CHAT_LOADING = "SEND_MESSAGE_CHAT_LOADING";
export const SEND_MESSAGE_CHAT_SUCCESS = "SEND_MESSAGE_CHAT_SUCCESS";
export const SEND_MESSAGE_CHAT_ERROR = "SEND_MESSAGE_CHAT_ERROR";

const sendMessageChatLoadingAction = (bool) => {
  return {
    type: SEND_MESSAGE_CHAT_LOADING,
    sendMessageChatLoading: bool
  };
};

const sendMessageChatSuccessAction = (bool, sendMessageChatData) => {
  return {
    type: SEND_MESSAGE_CHAT_SUCCESS,
    sendMessageChatSuccess: bool,
    sendMessageChatData
  };
};

const sendMessageChatErrorAction = (bool) => {
  return {
    type: SEND_MESSAGE_CHAT_ERROR,
    sendMessageChatError: bool
  };
};

export function sendMessageChat(data) {
  return (dispatch) => {
    dispatch(sendMessageChatLoadingAction(true));
    dispatch(sendMessageChatSuccessAction(false, null));
    dispatch(sendMessageChatErrorAction(false));

    let token = localStorage.getItem('tolaut@token') || null;
    let config = {};

    config = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(BASE_URL + SEND_MESSAGE_CHAT_URL, config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }

      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      dispatch(sendMessageChatLoadingAction(false));
      dispatch(sendMessageChatSuccessAction(true, data));
    })
    .catch((err) => {
      dispatch(sendMessageChatErrorAction(true));
    });
  };
};

const GET_USER_TYPE_URL = "chat/get-user-type";
export const GET_USER_TYPE_LOADING = "GET_USER_TYPE_LOADING";
export const GET_USER_TYPE_SUCCESS = "GET_USER_TYPE_SUCCESS";
export const GET_USER_TYPE_ERROR = "GET_USER_TYPE_ERROR";

const getUserTypeLoadingAction = (bool) => {
  return {
    type: GET_USER_TYPE_LOADING,
    getUserTypeLoading: bool
  };
};

const getUserTypeSuccessAction = (bool, getUserTypeData) => {
  return {
    type: GET_USER_TYPE_SUCCESS,
    getUserTypeSuccess: bool,
    getUserTypeData
  };
};

const getUserTypeErrorAction = (bool) => {
  return {
    type: GET_USER_TYPE_ERROR,
    getUserTypeError: bool
  };
};

export function getUserType() {
  return (dispatch) => {
    dispatch(getUserTypeLoadingAction(true));
    dispatch(getUserTypeSuccessAction(false, null));
    dispatch(getUserTypeErrorAction(false));

    let token = localStorage.getItem('tolaut@token') || null;
    let config = {};

    config = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    };

    fetch(BASE_URL + GET_USER_TYPE_URL, config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }

      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      dispatch(getUserTypeLoadingAction(false));
      dispatch(getUserTypeSuccessAction(true, data));
    })
    .catch((err) => {
      dispatch(getUserTypeErrorAction(true));
    });
  };
};

const GET_USER_ACTIVE_URL = "chat/get-user-active";
export const GET_USER_ACTIVE_LOADING = "GET_USER_ACTIVE_LOADING";
export const GET_USER_ACTIVE_SUCCESS = "GET_USER_ACTIVE_SUCCESS";
export const GET_USER_ACTIVE_ERROR = "GET_USER_ACTIVE_ERROR";

const getUserActiveLoadingAction = (bool) => {
  return {
    type: GET_USER_ACTIVE_LOADING,
    getUserActiveLoading: bool
  };
};

const getUserActiveSuccessAction = (bool, getUserActiveData) => {
  let arrUserActive = [];
  if(bool === true) {
    getUserActiveData.data.map((item, index) => ( 
      arrUserActive.push(
        {
          index: index,
          id: item.id,
          usery_type_id: item.usery_type_id,
          consignee: item.consignee,
          operator: item.operator,
          regulator: item.regulator,
          reseller: item.reseller,
          shipper: item.shipper,
          supplier: item.supplier,
          value: item.id,
          label:  item.consignee !== null ? item.consignee : 
                  item.operator !== null ? item.operator : 
                  item.regulator !== null ? item.regulator : 
                  item.reseller !== null ? item.reseller : 
                  item.shipper !== null ? item.shipper : 
                  item.supplier !== null ? item.supplier : 
                  "No Name",
        }
      )
    ));
  }

  return {
    type: GET_USER_ACTIVE_SUCCESS,
    getUserActiveSuccess: bool,
    getUserActiveData: arrUserActive
  };
};

const getUserActiveErrorAction = (bool) => {
  return {
    type: GET_USER_ACTIVE_ERROR,
    getUserActiveError: bool
  };
};

export function getUserActive(data) {
  return (dispatch) => {
    dispatch(getUserActiveLoadingAction(true));
    dispatch(getUserActiveSuccessAction(false, null));
    dispatch(getUserActiveErrorAction(false));

    let token = localStorage.getItem('tolaut@token') || null;
    let config = {};

    config = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(BASE_URL + GET_USER_ACTIVE_URL, config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }

      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      dispatch(getUserActiveLoadingAction(false));
      dispatch(getUserActiveSuccessAction(true, data));
    })
    .catch((err) => {
      dispatch(getUserActiveErrorAction(true));
    });
  };
};

const CREAT_ROOM_CHAT_URL = "chat/create-room";
export const CREAT_ROOM_CHAT_LOADING = "CREAT_ROOM_CHAT_LOADING";
export const CREAT_ROOM_CHAT_SUCCESS = "CREAT_ROOM_CHAT_SUCCESS";
export const CREAT_ROOM_CHAT_ERROR = "CREAT_ROOM_CHAT_ERROR";

const createRoomChatLoadingAction = (bool) => {
  return {
    type: CREAT_ROOM_CHAT_LOADING,
    createRoomChatLoading: bool
  };
};

const createRoomChatSuccessAction = (bool, createRoomChatData) => {
  return {
    type: CREAT_ROOM_CHAT_SUCCESS,
    createRoomChatSuccess: bool,
    createRoomChatData
  };
};

const createRoomChatErrorAction = (bool) => {
  return {
    type: CREAT_ROOM_CHAT_ERROR,
    createRoomChatError: bool
  };
};

export function createRoomChat(data) {
  return (dispatch) => {
    dispatch(createRoomChatLoadingAction(true));
    dispatch(createRoomChatSuccessAction(false, null));
    dispatch(createRoomChatErrorAction(false));

    let token = localStorage.getItem('tolaut@token') || null;
    let config = {};

    config = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(BASE_URL + CREAT_ROOM_CHAT_URL, config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }

      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      dispatch(createRoomChatLoadingAction(false));
      dispatch(createRoomChatSuccessAction(true, data));
    })
    .catch((err) => {
      dispatch(createRoomChatLoadingAction(false));
      dispatch(createRoomChatErrorAction(true));
    });
  };
};